<template>
    <div class="icons-container">
        <el-tabs type="border-card">
            <el-tab-pane label="Icons">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item><span class="icon_breadcrumb" @click="breadcrumbClick('')">Icons</span></el-breadcrumb-item>
                    <el-breadcrumb-item v-if="selectItem">
                        <span class="icon_breadcrumb" @click="breadcrumbClick(selectItem)">{{ selectItem }}</span>
                    </el-breadcrumb-item>
                </el-breadcrumb>
                <div v-for="(item, index) of svgIconsList" :key="index" @click="handleSelect(item, $event)">
                    <div v-if="!selectItem" class="icon-item">
                        <img v-if="item.file" src="/images/w-imgs/email/folder.png" alt="" style="width: 30px" />
                        <svg-icon v-else :icon-class="item.fileName" class-name="disabled" />
                        <span>{{ item.fileName }}</span>
                    </div>
                    <div v-else class="icon-item">
                        <el-tooltip placement="top">
                            <div slot="content">{{ generateIconCode(item) }}</div>
                            <div class="icon-item">
                                <svg-icon :icon-class="item" class-name="disabled" />
                                <span>{{ item }}</span>
                            </div>
                        </el-tooltip>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="Element-UI Icons">
                <div v-for="item of elementIcons" :key="item" @click="handleClipboard(generateElementIconCode(item), $event)">
                    <el-tooltip placement="top">
                        <div slot="content">
                            {{ generateElementIconCode(item) }}
                        </div>
                        <div class="icon-item">
                            <i :class="'el-icon-' + item" />
                            <span>{{ item }}</span>
                        </div>
                    </el-tooltip>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import clipboard from '@/wapp/common/utils/clipboard'
import svgIcons from './svg-icons'
import elementIcons from './element-icons'

export default {
    name: 'Icons',
    data() {
        return {
            svgIcons,
            elementIcons,
            defaultIconList: [],
            svgIconsList: [],
            selectItem: ''
        }
    },
    watch: {
        selectItem: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.svgIconsList = this.defaultIconList.filter((item) => item.fileName === newVal)[0].children
                } else {
                    this.svgIconsList = this.defaultIconList
                }
            }
        }
    },
    created() {
        // 创建一个空对象来存储分组结果
        var groupObj = {}
        // 遍历原始数组
        this.svgIcons.forEach((item) => {
            // 检查是否包含 '/'
            var parts = item.indexOf('/') !== -1 ? item.split('/') : [item, null]
            var fileName = parts[0]
            var iconName = parts[1]
            // 根据情况初始化 groupObj[fileName]
            if (!groupObj[fileName]) {
                groupObj[fileName] = {
                    fileName: fileName,
                    file: iconName !== null, // 如果没有 '/' 则视为文件
                    children: iconName !== null ? [iconName] : [] // 如果有 '/' 则添加 iconName
                }
            } else if (iconName !== null) {
                // 如果已经存在这个 fileName 并且 iconName 不是 null，则添加到 children
                groupObj[fileName].children.push(iconName)
            }
        })

        // 将 groupObj 对象的键值对转换为数组
        this.svgIconsList = Object.values(groupObj)
        this.defaultIconList = Object.values(groupObj)
        if (this.$parent.$el.className.indexOf('el-dialog') == -1) {
            this.$bus.$emit('showNavSearch', false)
        }
    },
    beforeDestroy() {
        if (this.$vnode.context.iconDialogFormVisible) {
            this.$bus.$emit('showNavSearch', true)
        }
    },
    methods: {
        handleSelect(item, event) {
            if (item.file) {
                this.selectItem = item.fileName
            } else {
                this.handleClipboard(item + '.svg', event)
            }
        },
        breadcrumbClick(str) {
            if (str) return
            this.selectItem = ''
        },
        generateIconCode(symbol) {
            return symbol.indexOf('/') !== -1 ? symbol.split('/')[1] + '.svg' : symbol + '.svg'
        },
        generateElementIconCode(symbol) {
            return symbol
        },
        handleClipboard(text, event) {
            clipboard(text, event)
            this.$bus.emit('onSelectedIcon', text)
            if (this.$vnode.context.iconDialogFormVisible) {
                if (this.$vnode.context.vo) {
                    if (this.$vnode.context.vo.icon !== undefined) {
                        this.$vnode.context.$set(this.$vnode.context.vo, 'icon', text)
                    } else if (this.$vnode.context.vo.code !== undefined) {
                        this.$vnode.context.$set(this.$vnode.context.vo, 'code', text)
                    }
                }
                if (this.$vnode.context.newMenu) {
                    this.$vnode.context.$set(this.$vnode.context.newMenu, 'code', text)
                }
                this.$vnode.context.$forceUpdate()
                this.$vnode.context.iconDialogFormVisible = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.icons-container {
    margin: 10px 20px 0;
    overflow: hidden;

    .icon-item {
        margin: 20px;
        height: 85px;
        text-align: center;
        width: 100px;
        float: left;
        font-size: 30px;
        color: #24292e;
        cursor: pointer;
    }

    span {
        display: block;
        font-size: 16px;
        margin-top: 10px;
    }

    .disabled {
        pointer-events: none;
    }
}
.el-breadcrumb {
    padding: 5px 10px;
    margin-top: -9px;
    background-color: #fff7f7;
    .el-breadcrumb__item {
        margin-top: 0 !important;
    }
    .icon_breadcrumb {
        display: inline-block;
        margin-top: 0;
        cursor: pointer;
        &:hover {
            color: #409eff;
        }
    }
}
</style>
